import { PushType } from './common/EnumTypes';
import { ScopeCheck } from './common/ScopeCheck';
import { ControllerProvider } from './ControllerProvider';
import { UserState } from './data/UserState';
import { StorageService } from './storage/StorageService';
import { DateCalculator } from './survey/DateCalculator';

export class OptOutHandler {
	private _optOutSelection: PushType[];
	private _controllerProvider: ControllerProvider; // Check if "controllerProvider" can be provided in constructor ???

	constructor() {
		this._optOutSelection = [];
	}

	public set controllerProvider(value: ControllerProvider) {
		this._controllerProvider = value;
		if (this._optOutSelection.length > 0) {
			this._updateTimedPush();
		}
	}

	public get controllerProvider(): ControllerProvider {
		return this._controllerProvider;
	}

	public getCurrentSelection(): PushType[] {
		return this._optOutSelection;
	}

	public addOptOut(pushType: PushType) {
		if (!this._optOutSelection.includes(pushType)) {
			this._optOutSelection.push(pushType);
		}
		this._updateTimedPush();
	}

	public removeOptOut(pushType: PushType) {
		if (this._optOutSelection.includes(pushType)) {
			this._optOutSelection = this._optOutSelection.filter(function (item) {
				return item !== pushType;
			});

			if (pushType === PushType.timedPush) {
				this._updateTimedPush();
			} else if (pushType === PushType.appPush) {
				this._updateAppPush();
			}
		}
	}

	public hasOptedOutFromAppPush(): boolean {
		if (this._optOutSelection.includes(PushType.appPush)) {
			return true;
		}
		return false;
	}

	public hasOptedOutFromTimedPush(): boolean {
		if (this._optOutSelection.includes(PushType.timedPush)) {
			return true;
		}
		return false;
	}

	public hasOptedOutFromInstantPush(): boolean {
		if (this._optOutSelection.includes(PushType.instantPush)) {
			return true;
		}
		return false;
	}

	private _updateTimedPush() {
		const hasOptedOut = this.hasOptedOutFromTimedPush();
		if (this._controllerProvider && this._controllerProvider.timedPushController) {
			if (ScopeCheck.isTimedPushAvailable(this._controllerProvider.centralConfig.startupConfig)) {
				if (!hasOptedOut) {
					this._calculateNextTimedPushDate();
				}
				this._controllerProvider.timedPushController.hasOptedOut = hasOptedOut;
			}
		}
	}

	private _updateAppPush() {
		if (this._controllerProvider) {
			if (ScopeCheck.isAppPushAvailable(this._controllerProvider.centralConfig.startupConfig)) {
				this._calculateNextAppPushDate();
			}
		}
	}

	private _calculateNextTimedPushDate() {
		if (this._controllerProvider) {
			const storageService = this._controllerProvider.storageService;
			if (storageService) {
				const pushConfig = this._controllerProvider.centralConfig.pushConfig;
				const userState = this._getUserState(storageService);
				if (userState && pushConfig) {
					userState.timedPushDate = DateCalculator.calculateNextTimedPushDate(pushConfig);
					this._saveUserState(storageService, userState);
				}
			}
		}
	}

	private _calculateNextAppPushDate() {
		if (this._controllerProvider) {
			const storageService = this._controllerProvider.storageService;
			if (storageService) {
				const pushConfig = this._controllerProvider.centralConfig.pushConfig;
				const userState = this._getUserState(storageService);
				if (pushConfig && userState) {
					userState.appPushDate = DateCalculator.calculateNextAppPushDate(pushConfig);
					this._saveUserState(storageService, userState);
				}
			}
		}
	}

	private _getUserState(storage: StorageService) {
		return storage.readUserState();
	}

	private _saveUserState(storage: StorageService, userState: UserState) {
		storage.saveUserState(userState);
	}
}
